import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Camille D.',
  city: 'Lyon'
}, {
  name: 'Émilie R.',
  city: 'Paris'
}, {
  name: 'Sophie L.',
  city: 'Bordeaux'
}, {
  name: 'Amélie B.',
  city: 'Marseille'
}, {
  name: 'Céline M.',
  city: 'Lille'
}, {
  name: 'Julie T.',
  city: 'Nantes'
}, {
  name: 'Laura P.',
  city: 'Toulouse'
}, {
  name: 'Manon G.',
  city: 'Strasbourg'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const show = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6000);
    };
    const firstPopup = window.setTimeout(show, 3500);
    const interval = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(firstPopup);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div role="status" aria-live="polite" className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-154" data-mp="27gavpjn1t1mq">
      <div className="bg-brand-violet border-2 border-brand-gold shadow-[0_0_18px_rgba(229,71,136,0.55)] rounded-lg px-2.5 py-2 pr-7 max-w-[290px] w-full relative pointer-events-auto" data-id="element-155" data-mp="1xp6f6fhq58ps">
        <button onClick={() => setVisible(false)} aria-label="Fermer la notification" className="absolute top-1 right-1 text-white/60 hover:text-white" data-id="element-156" data-mp="2qd2abfrnaskg">
          <XIcon className="w-3.5 h-3.5" data-id="element-157" data-mp="2ge3ammouy79l" />
        </button>
        <div className="flex items-center gap-2" data-id="element-158" data-mp="2ce2wl35o7y32">
          <div className="w-8 h-8 rounded-full bg-brand-magenta flex items-center justify-center shrink-0 border border-white/60" data-id="element-159" data-mp="2cd9lxr3lcofn">
            <ShoppingBagIcon className="w-4 h-4 text-white" data-id="element-160" data-mp="10ynq98rkntva" />
          </div>
          <div className="leading-tight" data-id="element-161" data-mp="10xcpzixc548x">
            <p className="font-bold text-white text-[11px]" data-id="element-162" data-mp="12f9xw0zayke6">
              {current.name} de {current.city}, France
            </p>
            <p className="text-[10px] text-brand-pink font-semibold" data-id="element-163" data-mp="17dl8wf1c30xz">vient d&apos;acheter ce livre numérique</p>
          </div>
        </div>
      </div>
    </div>;
}